/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransferDisclaimer } from '../../models/transfer-disclaimer';

export interface PutTransferdisclaimerId$Params {
  id: string;
  'api-version'?: string;
      body?: TransferDisclaimer
}

export function putTransferdisclaimerId(http: HttpClient, rootUrl: string, params: PutTransferdisclaimerId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putTransferdisclaimerId.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putTransferdisclaimerId.PATH = '/transferdisclaimer/{id}';
